import { useRef } from "react"

import Style from "./style"

import MainHeader from "widget/MainHeader"

import usePostImgUpload from "entity/util/usePostImgUpload"
import usePostVideoUpload from "entity/util/usePostVideoUpload"
import useGetAdvertiseDetail from "entity/advertiseTimer/useGetAdvertiseDetail"
import usePutAdvertise from "entity/advertiseTimer/usePutAdvertise"

import CStyle from "shared/style/commonStyle"
import DefaultButton from "shared/ui/DefaultButton"

const AdTimerEdit = () => {
    const srcRef = useRef()
    const videoRef = useRef()

    const [advertiseData] = useGetAdvertiseDetail()
    const [src, uploadSrcEvent, deleteSrcEvent] = usePostImgUpload(advertiseData?.data?.src)
    const [video, uploadVideoEvent, deleteVideoEvent] = usePostVideoUpload(advertiseData?.data?.src)
    const [putAdvertise] = usePutAdvertise(src, video, advertiseData?.data?.type)

    const btnList = [
        {
            "label": "저장",
            "clickEvent": () => putAdvertise(),
            "deactive": false
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            {advertiseData?.data?.type === "image" &&
                <Style.AreaDiv>
                    <h2>이미지 첨부파일<span>*</span></h2>
                    <CStyle.GuideDiv>
                        <p>jpg, png 이미지 | 20mb 제한</p>
                    </CStyle.GuideDiv>
                    <DefaultButton small fitWidth clickEvent={() => srcRef.current.click()}>첨부하기</DefaultButton>
                    <input type="file" ref={srcRef} onChange={uploadSrcEvent} style={{ display: "none" }} />

                    <Style.ImgUploadDiv>
                        {src &&
                            <Style.ImgElement>
                                <button onClick={deleteSrcEvent}>삭제</button>
                                <img src={src} onClick={() => window.open(src, "_blank")} />
                            </Style.ImgElement>
                        }
                    </Style.ImgUploadDiv>
                </Style.AreaDiv>
            }

            {advertiseData?.data?.type === "video" &&
                <Style.AreaDiv>
                    <h2>동영상 첨부파일<span>*</span></h2>
                    <CStyle.GuideDiv>
                        <p>avi, mp4, wmv 동영상 | 50mb 제한</p>
                    </CStyle.GuideDiv>
                    <DefaultButton small fitWidth clickEvent={() => videoRef.current.click()}>첨부하기</DefaultButton>
                    <input type="file" ref={videoRef} onChange={uploadVideoEvent} style={{ display: "none" }} />

                    <Style.ImgUploadDiv>
                        {video &&
                            <Style.ImgElement>
                                <button onClick={deleteVideoEvent}>삭제</button>
                                <video src={video} controls />
                            </Style.ImgElement>
                        }
                    </Style.ImgUploadDiv>
                </Style.AreaDiv>
            }

        </Style.Wrapper>
    )
}

export default AdTimerEdit